// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const filesKeys = {
  all: ['files'] as const,
  uploadIntents: (uploadIntentIds: string[]) =>
    [...filesKeys.all, uploadIntentIds] as const,
  upload: (uploadId: string) => {
    return [...filesKeys.all, uploadId] as const;
  },
  documentFormPdfUrl: (documentId: string) =>
    [...filesKeys.all, 'documentFormPdfUrl', documentId] as const,
};

export default filesKeys;
